import * as React from 'react';
import { TableStateMapping } from 'constants/service/tableStateConstants';
import { ToggleButton, ToggleButtonGroup } from 'bento';
import _ from 'lodash';

const stateOptions = _.map(TableStateMapping, (state) => {
  return {
    key: state.value,
    value: state.value,
    label: state.text,
  };
});

interface Props {
  state: string;
  onChange(newState: string): void;
}

const TableStateForm: React.FC<Props> = ({ state, onChange }) => {
  return (
    <ToggleButtonGroup
      exclusive={true}
      fullWidth
      value={state}
      onChange={(_, value) => {
        if (value) {
          onChange(value);
        }
      }}
    >
      {stateOptions.map((stateOption) => (
        <ToggleButton
          value={stateOption.value}
          key={stateOption.value}
          data-testid={'state_' + stateOption.value}
        >
          {stateOption.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default TableStateForm;
